@if (telling(); as stand) {
    <div class="dl-modelactie__telling">
        <span [class.dl-modelactie__goed]="stand.aantal === stand.totaal"
              [class.dl-modelactie__veel]="stand.aantal > stand.totaal">{{ stand.aantal }}</span>
        / {{ stand.totaal }}
        / <span [class.dl-modelactie__fouten]="stand.fout > 0">{{ stand.fout }}</span>
    </div>
} @else {
    <div class="dl-modelactie__telling">? / ? / ?</div>
}

<div class="dl-modelactie__graphholder" #houder>
    <canvas #canvas (mousemove)="opMuisbeweging($event)" (mouseout)="opMuisWeg()"></canvas>
    @if (popup(); as melding) {
        <div class="dl-modelactie__popup"
             [style.top.px]="melding.top"
             [style.bottom.px]="melding.bottom"
             [style.left.px]="melding.left"
             [style.right.px]="melding.right">{{ melding.tijdstip }}<br>
            @if (melding.telling; as stand) {
                <span>{{ stand.aantal }} / {{ stand.totaal }} / {{ stand.fout }}</span>
            } @else {
                <span>? / ? / ?</span>
            }
        </div>
    }
</div>

@if (modelrij(); as model) {
    <div class="dl-modelactie__onderschrift">
        <div [style.margin-left.px]="xStart">{{ startLabel() }}</div>
        <div class="dl-modelactie__titel"
             [class.dl-modelactie__titel--live]="model.live"
             [class.dl-modelactie__titel--primary]="model.rol === 'primary'"
             [class.dl-modelactie__titel--sub]="model.rol === 'sub'"
             [title]="'DASHBOARDV2.TITLES.MODELTYPE.' + model.rol | translate">{{ model.user }} - {{ model.titel }}</div>
        <div>{{ eindLabel() }}</div>
    </div>
}
